import { Textarea } from "@/src/components/ui/textarea";
import { useToast } from "@/src/components/ui/use-toast";
import { useFetch } from "@/src/lib/useFetch";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/src/components/ui/button";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { PostTownValues, PostTownSchema } from "../schemas";
import { Label } from "@/src/components/ui/label";
import { RelationSingleInput } from "../components/RelationSingleInput";
import { Country } from "../model";
import { FormErrors } from "../components/FormErrors";

export function AddTown() {
  const { fetch } = useFetch();
  const { toast } = useToast();
  const navigate = useNavigate();

  const onSubmit = async (data: PostTownValues) => {
    try {
      const response = await fetch<{ data: { id: string } }>("/api/locations/towns", "POST", data);
      toast({ title: "Success", description: "Town added successfully" });
      navigate(`/locations/towns/${response.data.id}`);
    } catch (error) {
      toast({ title: "Error", description: "Failed to add town", variant: "destructive" });
    }
  };

  return (
    <div className="rounded-2xl shadow-md bg-white p-4">
      <h2 className="text-lg font-semibold">Add Town</h2>
      <EditTownForm onSubmit={onSubmit} />
    </div>
  );
}

export function EditTownForm({ onSubmit }: { onSubmit: (data: PostTownValues) => void }) {
  const { fetch } = useFetch();

  const loadCountries = async (q: string) => {
    const data = await fetch<{ data: Country[] }>(
      `/api/locations/countries?page=1&pageSize=100&filter=${encodeURIComponent(q)}`,
    );
    return data.data;
  };

  const methods = useForm<PostTownValues>({
    resolver: zodResolver(PostTownSchema),
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit, console.error)} className="space-y-4 p-4">
        <div>
          <Label>Names</Label>
          <Textarea {...methods.register("names")} placeholder="Enter names, one per line" />
        </div>

        <div>
          <Label>Notes</Label>
          <Textarea {...methods.register("notes")} placeholder="Notes" />
        </div>

        <RelationSingleInput name="country" label="Country" loadOptions={loadCountries} />

        <FormErrors errors={methods.formState.errors} />

        <Button type="submit">Save</Button>
      </form>
    </FormProvider>
  );
}
